import { Col, Divider, Row } from "antd";
import DateRenderer from "components/DateRenderer";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import QuestionnaireStatus from "../../../../../../../backend-models/questionnaireStatus";
import QuestionnaireType from "../../../../../../../backend-models/questionnaireType";

const QuestionnaireDetails = ({ questionnaire }) => {
  const { t } = useTranslation();
  const { forumGroups } = questionnaire;

  const groups = useMemo(() => {
    return forumGroups?.map(({ name }) => name).join(", ");
  }, [forumGroups]);

  return (
    <Row gutter={24}>
      <Col className="gutter-row" span={12} lg={24} md={24}>
        <Row gutter={6}>
          <Col className="gutter-row" span={12}>
            <label htmlFor="questionnaireName">{t("Questionnaire name")}</label>
          </Col>
          <Col className="gutter-row" span={12}>
            <span id="questionnaireName">{questionnaire.name || "-"}</span>
          </Col>
        </Row>
        <Divider />
        <Row gutter={6}>
          <Col className="gutter-row" span={12}>
            <label htmlFor="availableFrom">{t("Available from")}</label>
          </Col>
          <Col className="gutter-row" span={12}>
            <span id="availableFrom">
              {questionnaire.availableFrom ? <DateRenderer date={questionnaire.availableFrom} /> : "-"}
            </span>
          </Col>
        </Row>
        <Divider />
        <Row gutter={6}>
          <Col className="gutter-row" span={12}>
            <label htmlFor="availableTo">{t("Available to")}</label>
          </Col>
          <Col className="gutter-row" span={12}>
            <span id="availableTo">
              {questionnaire.availableTo ? <DateRenderer date={questionnaire.availableTo} /> : "-"}
            </span>
          </Col>
        </Row>
        <Divider />
        <Row gutter={6}>
          <Col className="gutter-row" span={12}>
            <label htmlFor="questionnaireType">{t("Questionnaire type")}</label>
          </Col>
          <Col className="gutter-row" span={12}>
            <span id="questionnaireType">{t(new QuestionnaireType(questionnaire.type).toString()) || "-"}</span>
          </Col>
        </Row>
        <Divider />
        <Row gutter={6}>
          <Col className="gutter-row" span={12}>
            <label htmlFor="questionnaireGroup">{t("Questionnaire group")}</label>
          </Col>
          <Col className="gutter-row" span={12}>
            <span id="questionnaireGroup">{groups || "-"}</span>
          </Col>
        </Row>
        <Divider />
        <Row gutter={6}>
          <Col className="gutter-row" span={12}>
            <label htmlFor="questionnaireStatus">{t("Questionnaire status")}</label>
          </Col>
          <Col className="gutter-row" span={12}>
            <span id="questionnaireStatus">{t(new QuestionnaireStatus(questionnaire.status).toString()) || "-"}</span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

QuestionnaireDetails.propTypes = {
  questionnaire: PropTypes.shape({
    name: PropTypes.string,
    availableFrom: PropTypes.string,
    availableTo: PropTypes.string,
    type: PropTypes.oneOf(QuestionnaireType.LIST),
    status: PropTypes.oneOf(QuestionnaireStatus.LIST),
    forumGroups: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
  }),
};

export default QuestionnaireDetails;
